// Firebase configuration
import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  // Demo тохиргоо - жинхэнэ Firebase project үүсгэсний дараа солино уу
  apiKey: "demo-api-key",
  authDomain: "demo-burger-ai.firebaseapp.com", 
  projectId: "demo-burger-ai",
  storageBucket: "demo-burger-ai.appspot.com",
  messagingSenderId: "123456789",
  appId: "1:123456789:web:demo123456789"
};

// Firebase эхлүүлэх
const app = initializeApp(firebaseConfig);

// Authentication болон Firestore хандах
export const auth = getAuth(app);
export const db = getFirestore(app);

// Demo режимд ажиллаж байгааг мэдээлэх
if (firebaseConfig.apiKey === 'demo-api-key') {
  console.log('🎮 Firebase Demo режимд ажиллаж байна - жинхэнэ Firebase дээр холбогдохгүй');
}

export default app;
